export default {"src":"/_next/static/media/arrow-left-with-tail.d3498e7f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};